import { Editor, Viewer2DAPI } from '@/utils/Viewer2D';
import { Vector2 } from 'three';

export class Viewer2DHandle {
  readonly canvasDom: HTMLCanvasElement;
  readonly editor: Editor;
  readonly resizeObserver: ResizeObserver;
  readonly api: Viewer2DAPI;
  frameId = 0;

  constructor(args: { canvasDom: HTMLCanvasElement }) {
    this.canvasDom = args.canvasDom;
    this.editor = new Editor(args.canvasDom);
    this.api = { editor: this.editor };
    this.resizeObserver = this._createResizeObserver();
  }

  start() {
    this.resizeObserver.observe(this.canvasDom);

    // Main loop
    const update = () => {
      this.editor.update();
      this.frameId = requestAnimationFrame(update);
    };

    update();
  }

  stop() {
    this.resizeObserver.disconnect();
    cancelAnimationFrame(this.frameId);
  }

  private _createResizeObserver() {
    return new ResizeObserver(() => {
      const size = new Vector2(this.canvasDom.offsetWidth, this.canvasDom.offsetHeight);
      this.editor.setSize(size);
    });
  }
}
